module.exports = __webpack_public_path__ + "media/images/emblems/Rolle_district_coa-0b845f81f88b3bff804a3893e1ccdca4.png";